import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { formLabelStyling } from 'components/forms/new/formStyles';
import { FORM_FIELD_PATHS } from '../../constants';
import { stackSpacing, stackStyling } from 'components/forms/new/formStyles';

const DefaultTrunk = ({ darkMode, errors, trunks, isLoadingTrunks }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useCompanyForm();

    const handleSelectChange = (item) => {
        const selectedId = item?.id;
        updateFormData(FORM_FIELD_PATHS.DEFAULT_TRUNK_ID, selectedId);
    };

    const hasError = !!errors?.defaultTrunkID;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Default Trunk
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={DropDown}
                        id={FORM_FIELD_PATHS.DEFAULT_TRUNK_ID}
                        name={FORM_FIELD_PATHS.DEFAULT_TRUNK_ID}
                        data={trunks}
                        shownValue="name"
                        currentId={formData?.defaultTrunkID}
                        selectedId="id"
                        placeholder="Select default trunk"
                        handleSelectChange={handleSelectChange}
                        width="100%"
                        isLoading={isLoadingTrunks}
                        darkMode={darkMode}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the default trunk for this company"
                        ariaLabel="default-trunk-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default DefaultTrunk;
